<div
  rtScrollable
  class="sidebar"
  [class.has-expander]="hasExpander"
  [class.large]="size === 'large'"
  [class.collapsed]="collapseState === 'collapsed'"
  [@collapseHorizontal]="collapseState"
  (@collapseHorizontal.start)="animationEvent.emit($event)"
  (@collapseHorizontal.done)="animationEvent.emit($event)"
>
  <ng-content></ng-content>
</div>

@if (hasExpander) {
  <div class="expander-wrap">
    <div class="expander" (click)="toggleSidebar(!isMinimized)">
      <div
        class="controls-container"
        [class.collapsed]="isMinimized"
        [class.shortcuts-disabled]="!isMinimized && !enableExpanderShortcuts"
      >
        @if (!isMinimized && enableExpanderShortcuts) {
          <div class="hotkey-controls-group">
            <div class="symbol-wrapper" margin-right-small-xx>
              <span margin-lr-small-xxx>[</span>
            </div>
            <div class="symbol-wrapper">
              <span margin-lr-small-xxx>]</span>
            </div>
            <div class="label">{{ 'app.sidebar.show_hide' | translate }}</div>
          </div>
        }
        <rt-icon [name]="isMinimized ? 'chevron-right' : 'chevron-left'"></rt-icon>
      </div>
    </div>
  </div>
}
